import { colors, font } from '@chegg-ui/theme';
import styled from 'styled-components';
export var SliderContentWrapper = styled.div.withConfig({
  componentId: "dqb22u-0"
})(["max-width:21.125rem;max-height:30rem;background:", ";"], colors.white);
export var SliderItem = styled.div.withConfig({
  componentId: "dqb22u-1"
})(["background:", ";display:flex;flex-direction:column;justify-content:space-between;align-items:center;height:14.25rem;padding:1.25rem;"], colors.greyXlight);
export var SliderItemTitle = styled.h3.withConfig({
  componentId: "dqb22u-2"
})(["margin:0;font-size:", ";font-family:", ";font-weight:", ";color:", ";"], font.size.px24, font.family["default"], font.weight.bold, colors.dark);
export var SliderItemDescription = styled.span.withConfig({
  componentId: "dqb22u-3"
})(["font-size:", ";font-family:", ";font-weight:", ";color:", ";text-align:center;"], font.size.px18, font.family["default"], font.weight.bold, colors.dark);
export var SliderItemImage = styled.img.withConfig({
  componentId: "dqb22u-4"
})(["width:9.25rem;"]);